module.exports = __webpack_public_path__ + "static/Zonos-3e928cc7a5acfccdf22134fdf10b5996.svg";